import Axios from "../../Config/API";
import {
    lstFuncoesGrupoInterface,
    VincularFuncoesGrupoInterface,
} from "../../../Interfaces/Geral/Grupos/GruposFuncaoInterface";
import Service from "../../Service";

export async function DesvincularFuncaoGrupoService(IDFuncaoGrupo: number[]) {
    return Service(
        Axios.put(`/home/gruposfuncao/desvincularfuncaogrupo`, IDFuncaoGrupo)
    );
}

export async function VincularFuncoesGrupoService(
    requestBody: VincularFuncoesGrupoInterface[]
) {
    return Service(
        Axios.post(`/home/gruposfuncao/vincularfuncoesgrupo`, requestBody)
    );
}

export async function ListarFuncoesVinculadasPorGrupoService(IDGrupo: number) {
    return Service(
        Axios.get<Array<lstFuncoesGrupoInterface>>(
            `/home/gruposfuncao/listarfuncoesvinculadasporgrupo?IDGrupo=${IDGrupo}`
        )
    );
}

export async function ListarFuncoesVinculadasPorGrupoeSistemaService(
    IDGrupo: number,
    IDSistema: number
) {
    return Service(
        Axios.get<Array<lstFuncoesGrupoInterface>>(
            `/home/gruposfuncao/listarfuncoesvinculadasporgrupoesistema?IDGrupo=${IDGrupo}&IDSistema=${IDSistema}`
        )
    );
}

export async function ListarFuncoesNaoVinculadasPorGrupoService(
    IDGrupo: number
) {
    return Service(
        Axios.get<Array<lstFuncoesGrupoInterface>>(
            `/home/gruposfuncao/listarfuncoesnaovinculadasporgrupo?IDGrupo=${IDGrupo}`
        )
    );
}

export async function ListarFuncoesNaoVinculadosPorGrupoeSistemaService(
    IDGrupo: number,
    IDSistema: number
) {
    return Service(
        Axios.get<Array<lstFuncoesGrupoInterface>>(
            `/home/gruposfuncao/listarfuncoesnaovinculadosporgrupoesistema?IDGrupo=${IDGrupo}&IDSistema=${IDSistema}`
        )
    );
}
